// import { Layer } from 'leaflet';
import React, { useRef, useEffect } from 'react';
import L from 'leaflet';
import { MapContainer, TileLayer, useMap, Marker, Popup, GeoJSON, LayersControl, LayerGroup, Tooltip, Polyline } from 'react-leaflet'
// import brbr from '../geo/brasil-ibge.json'
import aux_mapa from '../helper/aux_mapa';


function MapLeaflet(props) {
    // const [updateCounter, setUpdateCounter] = useState(0);
    //console.log("# DADOS #", props?.dados);

    let popupRef = useRef();

    //console.log(L);

    const geoJsonLayerEstados = React.createRef();
    const geoJsonLayer = React.createRef();
    // console.log(props?.desenhoMapa);

    const MyMarker = props => {

        const initMarker = ref => {
            if (ref) {
                ref.leafletElement?.openPopup()
            }
        }

        return <Marker ref={initMarker} {...props} />
    }

    function getMarker(position) {
        return `<Marker position={[${position?.lat}, ${position?.lng}]}>
            <Tooltip sticky permanent opacity={1}>
                TTTT <br /> Dados.<br />
                
            </Tooltip>
    </Marker>`
    }

    function onEachFeature(feature, layer) {
        layer.on('click', function (e) {
            // e = event
            if (e?.target?.feature?.properties?.codarea) {
                const codarea = e?.target?.feature?.properties?.codarea || 0
                if (codarea && codarea < 100) {
                    props.estadoHandler(codarea)
                }
            }
            // You can make your ajax call declaration here
            //$.ajax(... 
        });
        //const position = layer.getBounds().getCenter()
        // console.log({ id: feature.properties.id, municipio: feature.properties.name, lat: position.lat, lng: position.lng });


        // if (feature.properties && feature.properties.codarea) {

        //     let pop = ` <h5>${feature.properties.codarea}</h5> <p>${position?.lat}</p> <p>${position?.lng}</p> `;
        //     // console.log('FPROS ---- ', layer.getBounds().getCenter());
        //     // if (feature.properties.codarea == 35) {
        //     pop = getMarker(position)
        //     // }
        //     layer.bindTooltip(pop);
        // }
        // console.log('layer', layer);
        // console.log('FEATURE ### ', geoJsonLayerEstados);
    }

    function styleRandom(feature) {

        if (feature.properties?.codarea == 135)
            return {
                //#800026
                fillColor: '#547B01',
                // fillColor: corRegular[0],
                weight: 2,
                opacity: 1,
                color: 'white',
                dashArray: '3',
                fillOpacity: 0.9
            };
        else
            return {
                fillColor: '#DCE4CC',
                // fillColor: corRegular[1],
                weight: 2,
                opacity: 1,
                color: 'white',
                dashArray: '3',
                fillOpacity: 0.9
            };
    }

    function getMarkerFotoVideo(options) {
        const idfo = props?.fiscalizacao + '/' || ''
        // let base_media_url = 'https://painel.tce.sp.gov.br/arquivos/questionario/media/' + idfo;
        // let base_media_url = 'https://pro-wa-dmza-pentaho.tce.sp.gov.br/arquivos/questionario/externo/arquivos/' + idfo;
        let base_media_url = 'https://painel.tce.sp.gov.br/arquivos/questionario/externo/arquivos/' + idfo;
        if ([268].includes(props?.fiscalizacao)) {
            base_media_url = 'https://wsm.tce.sp.gov.br/arquivos-fo/';
        }
        let url = ''
        if (options?.dado) {
            const item = options?.dado
            url = base_media_url + item.imagem;
            let videoOrImage = getVideoOrImageHtml(base_media_url, item.imagem)
            const icon = getColoredIcon(options?.color)
            const bgColor = getBackgroundColor(options?.color)
            const lineColor = getLineColor(options?.color)
            return (<>
                <MyMarker position={[item.lat, item.lng]} icon={icon} >
                    <Tooltip sticky={false} permanent opacity={1} direction="bottom" position={getPositionTooltip(options?.local)} >
                        <div key={Math.random() * 10000000 + item.municipio + item.descricao} style={{
                            minWidth: '200px', minHeight: '200px', maxWidth: '280px',
                            maxHeight: '290px', overflow: 'hidden', whiteSpace: 'normal', backgroundColor: bgColor
                        }}>
                            <b>{item.descr}</b> <br />
                            {item.descricao}.<br />
                            {getVideoOrImageHtml(base_media_url, item.imagem)}
                        </div>
                    </Tooltip>
                </MyMarker>
                <Polyline key={Math.random() * 1000000} positions={[
                    [item.lat, item.lng], getPositionTooltip(options?.local),
                ]} color={lineColor} weight='3' dashArray='10, 10' dashOffset='5' />
            </>
            )
        } else {
            return null
        }
    }

    function getPositionTooltip(local) {
        if (local === 'bottom-right') return aux_mapa.get_position_tooltip_by_key(props.estado).bottomRight
        if (local === 'bottom-left') return aux_mapa.get_position_tooltip_by_key(props.estado).bottomLeft
        if (local === 'top-right') return aux_mapa.get_position_tooltip_by_key(props.estado).topRight
    }

    function getVideoOrImageHtml(base_media_url, filename) {
        const fileExt = filename.split('.').pop();
        if (fileExt == 'mp4') {
            return (<video width="300" height="200" muted={true} autoPlay playsInline loop src={base_media_url + filename} type="video/mp4" />)
        } else if (fileExt == 'jpg' || fileExt == 'jpeg' || fileExt == 'png' || fileExt == 'gif') {
            return (<img height="200" width="300" src={base_media_url + filename} />)

        }
    }

    function getGeoJsonToDraw(estado) {
        const codEstado = estado || props?.estado
        if (codEstado) {
            const desenho_mapa = aux_mapa.get_geoJson_by_key(codEstado)
            return (<GeoJSON key={"geo" + codEstado} data={desenho_mapa} ref={geoJsonLayerEstados} style={styleRandom} onEachFeature={onEachFeature} />)
        } else {
            return null
        }
    }

    function getColoredIcon(color) {
        const LeafIcon = L.Icon.extend({
            options: {}
        });
        const greenIcon = new LeafIcon({
            iconUrl: process.env.PUBLIC_URL + '/green.png'

        });

        const blueIcon = new LeafIcon({
            iconUrl: process.env.PUBLIC_URL + '/marker-azul.png'
        });

        const redIcon = new LeafIcon({
            iconUrl: "https://unpkg.com/ionicons@5.5.2/dist/svg/at-circle-outline.svg"
        });

        const yellowIcon = new LeafIcon({
            iconUrl: process.env.PUBLIC_URL + '/marker-icon-yellow.png'
        });


        if (color == 'green') {
            return greenIcon
        }
        if (color == 'yellow') {
            return yellowIcon
        }
        else {
            return blueIcon
        }
    }

    function getBackgroundColor(color) {
        if (color == 'green') {
            return '#84C497'
        }
        if (color == 'yellow') {
            return '#CAC428'
        } else {
            return '#7CB5EC'
        }
    }

    function getLineColor(color) {
        if (color == 'green') {
            return '#1e6e32'
        }
        if (color == 'yellow') {
            return '#988F2E'
        }
        else {
            return '#1d1682'
        }
    }

    function getZoom() {
        const cod_estado = props?.estado
        return aux_mapa.get_zoom_by_key(cod_estado)
    }

    const getTooltipsToShow = () => {

        // const dado = props?.dados[ Math.floor(Math.random() * props?.dados.length) ]
        var shuffled = props?.dados.sort(function () { return .5 - Math.random() });
        var item = shuffled.slice(0, 3);

        // var arrayEstados = shuffled.map(x=> (x.id+'').substring(0, 2))
        // const unicosEstados = new Set(arrayEstados)
        // const estadosUnicos = [...unicosEstados]
        //     console.log(estadosUnicos)

        // const estados = shuffled.reduce((acc,curr)=>{
        //     acc.add( curr.id.substring(0, 2))
        //     return acc
        // }, new Set())

        // console.log(estados)


        if (props?.dados?.length === 1) {
            return (<> {getMarkerFotoVideo({ local: 'top-right', color: 'green', dado: item[0] })} </>)
        }
        if (props?.dados?.length === 2) {
            return (<>
                {getMarkerFotoVideo({ local: 'top-right', color: 'green', dado: item[0] })}
                {getMarkerFotoVideo({ local: 'bottom-right', color: 'blue', dado: item[1] })}
            </>)
        }

        if (props?.dados?.length >= 3) {
            return (<>
                {getMarkerFotoVideo({ local: 'top-right', color: 'green', dado: item[0] })}
                {getMarkerFotoVideo({ local: 'bottom-right', color: 'blue', dado: item[1] })}
                {getMarkerFotoVideo({ local: 'bottom-left', color: 'yellow', dado: item[2] })}
            </>)
        }

    }

    return (
        <MapContainer center={[-23.376566863651192, -46.69949329460831]} style={{ backgroundColor: '#AAD3DF', width: '920px' }} dragging={false} zoom={getZoom()} scrollWheelZoom={false} attributionControl={false} whenReady={(a) => {
            console.log("This function will fire once the map is created")

        }}>
            {/* <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            /> */}
            <MapLeafletInner estado={props?.estado} />
            <LayersControl>
                <LayersControl.Overlay checked name="-1">
                    <LayerGroup attribution='OI'>
                        {getGeoJsonToDraw(props?.estado)}
                        {/* {getMarkerFotoVideo({local:'bottom-left'})} */}
                        {getTooltipsToShow()}

                    </LayerGroup>
                </LayersControl.Overlay>

                {/* <LayersControl.Overlay name="Todos">
                    <LayerGroup id="lg1"  >
                        <GeoJSON data={spsp} ref={geoJsonLayer} onEachFeature={onEachFeature} />

                         <MyMarker position={[-23.376566863651192, -46.69949329460831]}>
                            <Tooltip sticky permanent opacity={1}>
                                TTTT <br /> Dados.<br />
                                <video width="300" muted={true} autoPlay playsInline loop src="https://painel.tce.sp.gov.br/arquivos/questionario/media/85614-0-236493200.mp4" type="video/mp4" />
                            </Tooltip>
                        </MyMarker> 
                    </LayerGroup>
                </LayersControl.Overlay> */}
            </LayersControl>


        </MapContainer>
    )
}

function MapLeafletInner(props) {
    const estado = props?.estado
    const map = useMap()
    // map.setView()
    const zoom = aux_mapa.get_zoom_by_key(estado)
    const center = aux_mapa.get_center_by_key(estado)
    map.setZoom(zoom)
    map.setView(center, zoom)

    // L.geoJSON().clearLayers();
    // console.log('map center:', map, props?.estado)
    // map.eachLayer(x => {
    //     console.log('props?.estado:', props?.estado, x)
    //     if (props?.estado == x.name) {
    //         x.remove()
    //     }
    // })
    return null
}




export default MapLeaflet